import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Like pluck, but plucks from nested properties of a list of objects instead
 */
export function pluckList<T, P1 extends keyof T>(
  property1: P1,
): (source$: Observable<readonly T[]>) => Observable<readonly T[P1][]> {
  return map(xs => xs.map(x => x[property1]));
}
